module.exports = __webpack_public_path__ + "static/media/blood-7.493e7cc2.png";